import { LISTAR_TRONCOS, LISTAR_TRONCO_SELECIONADO, LISTAR_ROTAS, LISTAR_TRONCO_USE, LISTAR_GRUPOS_DE_ROTAS } from './mutation-types'

export default {
  [LISTAR_TRONCOS]: (state, troncos) => {
    state.troncos = troncos
  },
  [LISTAR_TRONCO_SELECIONADO]: (state, tronco) => {
    state.troncoSelecionado = tronco
  },
  [LISTAR_TRONCO_USE]: (state, troncoUse) => {
    state.troncoUse = troncoUse
  },
  [LISTAR_ROTAS]: (state, rotas) => {
    state.rotasDisponiveis = rotas
  },
  [LISTAR_GRUPOS_DE_ROTAS]: (state, gruposDeRotas) => {
    state.gruposDeRotas = gruposDeRotas
  },
}
